import React, { useEffect } from 'react';
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import { motion } from "framer-motion";
import image from '../images/ridley-gravel.jpg';
import kolo from '../images/bike.png';
import { NavLink, useParams } from 'react-router-dom';
import builder from "../utils/builderWithLocale";
import { getBikeField } from '../editry/cms';
import { getLocalizedText } from '../utils/textLocalization';

function App() {
  const { category } = useParams();
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [bikeData, setBikeData] = React.useState({});

  const buttonText = getLocalizedText('pruvodce.button');

  useEffect(() => {
    setLoading(true);
    setError(null);
    
    Promise.all([
      builder.getAll("pruvodce"),
      builder.getAll("kola")
    ])
      .then(([pruvodceResponse, kolaResponse]) => {
        const matchedData = pruvodceResponse.find(item => 
          item.name === category
        );
        
        if (matchedData) {
          document.title = getLocalizedText('pruvodce.page_title');
          setData(matchedData.data);
          
          // Create bike map from all fetched bikes
          const bikeMap = {};
          kolaResponse.forEach(bike => {
            if (bike.id) {
              bikeMap[bike.id] = bike;
            }
          });
          console.log('Loaded bikes:', bikeMap);
          setBikeData(bikeMap);
        } else {
          console.warn('No data found for category:', category);
          setError(`Průvodce pro kategorii "${category}" nebyl nalezen`);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching pruvodce data:', err);
        setError('Nepodařilo se načíst data průvodce');
        setLoading(false);
      });
  }, [category]);

  if (loading) {
    return (
      <motion.div className="page" key="loading" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
        <div className="pruvodce-page-blocker">
          <img src={image} alt="Ridley Gravel Bike" />
          <h1>Načítání...</h1>
          <h2>Připravujeme pro vás průvodce</h2>
        </div>
      </motion.div>
    );
  }

  if (error) {
    return (
      <motion.div className="page" key="error" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
        <div className="pruvodce-page-blocker">
          <img src={image} alt="Ridley Gravel Bike" />
          <h1>Chyba</h1>
          <h2>{error}</h2>
        </div>
      </motion.div>
    );
  }

  if (!data) {
    return (
      <motion.div className="page" key="no-data" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
        <div className="pruvodce-page-blocker">
          <img src={image} alt="Ridley Gravel Bike" />
          <h1>Průvodce není dostupný</h1>
          <h2>Data se nepodařilo načíst</h2>
        </div>
      </motion.div>
    );
  }

  return (
    <>
      <motion.div className="page" key="content" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
        <div className="pruvodce-page-blocker">
          <img src={data.obrazek + "?format=webp"} alt="Ridley Gravel Bike" />
          <div className="page-background-pruvodce-div" />
          <h1>{data.nadpis?.Default || data.nadpis || 'Průvodce kol Gravel'}</h1>
          <h2>{data.popis?.Default || data.popis || 'Vše, co potřebujete vědět o kolech Gravel'}</h2>
        </div>
        <div className="pruvodce-page-content">
          {data.sekce && data.sekce.map((sekce, index) => (
            <div className="pruvodce-page-item" key={index}>
              <h1>{sekce.nadpis?.Default || sekce.nadpis}</h1>
              <div dangerouslySetInnerHTML={{ __html: sekce.popis?.Default || sekce.popis }} />
              {/* <img src={"https://highland-sport.cz/cdn/shop/collections/gravel.jpg?crop=center&height=600&v=1753975200&width=1200"} alt="Obrázek" className='pruvodce-sekce-image' /> */}
              {sekce.obrazek && <img src={sekce.obrazek + "?format=webp"} alt="Obrázek" className='pruvodce-sekce-image'/> }
              
              {sekce.kola && sekce.kola.map((koloItem, koloIndex) => {
                const koloRef = koloItem.kolo;
                const koloId = koloRef?.id;
                
                if (!koloId) {
                  return null;
                }
                
                const bike = bikeData[koloId];
                if (!bike) {
                  console.log('Bike not loaded yet:', koloId);
                  return null;
                }
                
                const koloData = bike.data;
                
                const nazev = koloData.nazev?.Default || koloData.nazev;
                const oProduktuRaw = getBikeField(koloData, 'oProduktu');
                const oProduktu = oProduktuRaw?.Default || oProduktuRaw;
                const obrazek = koloData.obrazek?.Default || koloData.obrazek;
                
                return (
                  <div className="pruvodce-page-bike-content" key={koloIndex}>
                    <div>
                      <img 
                        src={obrazek || kolo} 
                        alt={nazev || "Ridley Bike Image"} 
                      />
                    </div>
                    <h2>{nazev || 'Bike name'}</h2>
                    <h3>{oProduktu || 'Popis produktu není dostupný'}</h3>
                    {/* TODO implementování i pro ostatní kategorie, při přidávání dalších průvodců */}
                    <NavLink to={"/kola/gravel/" + koloId}>
                      <button><span>{buttonText}</span></button>
                    </NavLink>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </motion.div>
    </>
  );
}

export default App;